export default {
  sourcesLabel: "Sources",
  items: [
    {
      title: "Facts",
      link: "/fact-sheets",
      background: require("@assets/images/toolkits/toolkit1_bg.png"),
      placeholder: require("@assets/images/toolkits/toolkit1_thumb.png"),
      sources: [
        {
          prelabel: "1. Williams Institute,",
          label:
            "LGBT people nearly four times more likely than non-LGBT people to be victims of violent crime",
          sublabel: ". October 2, 2020.",
          link: "https://williamsinstitute.law.ucla.edu/press/ncvs-lgbt-violence-press-release/",
        },
        {
          prelabel: "2. U.S. Department of Justice,",
          label: "Hate Crimes | Facts and Statistics",
          sublabel: ". September 23, 2024.",
          link: "https://www.justice.gov/hatecrimes/hate-crime-statistics",
        },
        {
          prelabel: "3. The Trevor Project,",
          label: "Sexual Violence and Suicide Risk among LGBTQ+ Young People",
          sublabel: ". March 27, 2024.",
          link: "https://www.thetrevorproject.org/research-briefs/sexual-violence-and-suicide-risk-among-lgbtq-young-people",
        },
        {
          prelabel: "4. Centers for Disease Control and Prevention (CDC),",
          label:
            "Youth Risk Behavior Survey Data Summary & Trends Report: 2013-2023.",
          sublabel: "",
          link: "https://www.cdc.gov/yrbs/dstr/pdf/YRBS-2023-Data-Summary-Trend-Report.pdf",
        },
        {
          prelabel: "5. CDC,",
          label:
            "Youth Risk Behavior Survey Data Summary & Trends Report: 2013-2023.",
          sublabel: "",
          link: "https://www.cdc.gov/yrbs/dstr/pdf/YRBS-2023-Data-Summary-Trend-Report.pdf",
        },
        {
          prelabel: "6. PMC,",
          label:
            "Sexual Violence, Stalking, and Intimate Partner Violence by Sexual Orientation, United States",
          sublabel: ". January 1, 2021.",
          link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC7020247/",
        },
        {
          prelabel: "7. National Institute of Mental Health,",
          label: "Mental Illness",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://www.nimh.nih.gov/health/statistics/mental-illness",
        },
        {
          prelabel: "8. American Psychiatric Association,",
          label: "Mental-Health-Facts-for-LGBTQ.pdf",
          sublabel: ". Published 2017. Accessed March 25, 2025.",
          link: "https://www.psychiatry.org/File Library/Psychiatrists/Cultural-Competency/Mental-Health-Disparities/Mental-Health-Facts-for-LGBTQ.pdf",
        },
        {
          prelabel: "9. Mental Health America,",
          label: "LGBTQ+ Communities and Mental Health",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://mhanational.org/resources/lgbtq-communities-and-mental-health/",
        },
        {
          prelabel: "10. The Trevor Project,",
          label: "LGBTQ+ Youth Suicide Statistics & Attempt Rates in the U.S. ",
          sublabel: "Accessed March 21, 2025.",
          link: "https://www.thetrevorproject.org/research-briefs/estimate-of-how-often-lgbtq-youth-attempt-suicide-in-the-u-s/",
        },
        {
          prelabel: "11. American Journal of Psychiatry,",
          label:
            "Disparities in Suicide-Related Behaviors Across Sexual Orientations by Gender: A Retrospective Cohort Study Using Linked Health Administrative Data",
          sublabel: ". June 7, 2023.",
          link: "https://psychiatryonline.org/ajp/doi/10.1176/appi.ajp.20220763",
        },
        {
          prelabel: "12. Mental Health America,",
          label: "LGBTQ+ Communities and Mental Health",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://mhanational.org/resources/lgbtq-communities-and-mental-health/",
        },
        {
          prelabel: "13. PMC,",
          label:
            "Suicide Attempts Among Racial and Ethnic Groups in a Nationally Representative Sample",
          sublabel: ". July 21, 2021.",
          link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC8294284/",
        },
        {
          prelabel: "14. Mental Health America,",
          label: "LGBTQ+ Communities and Mental Health",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://mhanational.org/resources/lgbtq-communities-and-mental-health/",
        },
        {
          prelabel: "15. American Psychiatric Association,",
          label: "Mental-Health-Facts-for-LGBTQ.pdf",
          sublabel: ". 2017. Accessed March 21, 2025.",
          link: "https://www.psychiatry.org/getmedia/552df1c0-57f2-4489-88fa-432182ce815a/Mental-Health-Facts-for-LGBTQ.pdf",
        },
      ],
      pdf: {
        link: "/assets/pdf/P365+_LGBTQ+_Fact_Sheet.pdf",
        title: "We're LGBTQ+",
        subtitle:
          "In search of an open, safe and respectful world. <strong>People.</strong>",
        img: {
          src: require("@assets/images/pdf_1.png"),
          placeholder: require("@assets/images/pdf_1_thumb.png"),
          alt: "LGBTQ+ Fact sheet pdf",
          width: 280,
          height: 120,
        },
      },
    },
    {
      title: "How to be an ally",
      link: "/how-to-be-an-ally",
      background: require("@assets/images/toolkits/toolkit2_bg.png"),
      placeholder: require("@assets/images/toolkits/toolkit2_thumb.png"),
      sources: [
        {
          prelabel: "GLAAD,",
          label: "Tips for Allies of Transgender People.",
          sublabel: "Accessed March 21, 2025.",
          link: "https://glaad.org/transgender/allies/#:~:text=The%20best%20way%20to%20be,people%20within%20the%20community%20face.",
        },
        {
          prelabel: "Harvard Business Review,",
          label: "Research: How to Be a Better Ally to the LGBTQ+ Community",
          sublabel: ". April 12, 2023.",
          link: "https://hbr.org/2023/04/research-how-to-be-a-better-ally-to-the-lgbtq-community",
        },
        {
          prelabel: "HRC,",
          label: "Being an LGBTQ+ Ally",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://reports.hrc.org/being-an-lgbtq-ally",
        },
        {
          prelabel: "",
          label:
            "The Trevor Project: A Guide to Being an Ally to Transgender and Nonbinary Youth",
          sublabel: ". Accessed March 21, 2025.",
          link: "https://www.thetrevorproject.org/resources/trevor-support-center/a-guide-to-being-an-ally-to-transgender-and-nonbinary-youth/",
        },
      ],
      pdf: {
        link: "/assets/pdf/P365+_LGBTQ+_Ally_Guide.pdf",
        title: "It’s me",
        subtitle: "Your colleague, friend, partner. <strong>Ally.</strong>",
        img: {
          src: require("@assets/images/pdf_2.png"),
          placeholder: require("@assets/images/pdf_2_thumb.png"),
          alt: "LGBTQ+ How to be an ally pdf",
          width: 280,
          height: 120,
        },
      },
    },
    {
      title: "Resources",
      link: "/resource-guides",
      background: require("@assets/images/toolkits/toolkit3_bg.png"),
      placeholder: require("@assets/images/toolkits/toolkit3_thumb.png"),
      substanceLabel: "Substance Use Disorders",
      helpline: [
        'Optum Substance Use helpline: <a href="tel:+1-855-780-5955"}>1-855-780-5955</a>',
        'SAMHSA’s National helpline: <a href="tel:+1-800-662-4357">1-800-662-4357</a> (HELP) and TTY <a href="tel:+1-800-487-4889"}>1-800-487-4889</a>',
      ],
      pdf: {
        link: "/assets/pdf/P365+_LGBTQ+_Resource_Guide.pdf",
        title: "It’s me",
        subtitle:
          "Colleague, friend, child, sibling, partner. <strong>Person.</strong>",
        img: {
          src: require("@assets/images/pdf_3.png"),
          placeholder: require("@assets/images/pdf_3_thumb.png"),
          alt: "LGBTQ+ Resource guide pdf",
          width: 280,
          height: 120,
        },
      },
      pdf2: {
        link: "/assets/pdf/P365+_Body_image_distress.pdf",
        title:
          "LGBTQIA+ folks often have more body image distress. Here’s why. ",
        img: {
          src: require("@assets/images/pdf_3a.png"),
          placeholder: require("@assets/images/pdf_3a_thumb.png"),
          alt: "LGBTQ+ Body image distress pdf",
          width: 280,
          height: 120,
        },
      },
    },
    {
      title: "Transgender support",
      link: "/transgender-support",
      background: require("@assets/images/toolkits/toolkit4_bg.png"),
      placeholder: require("@assets/images/toolkits/toolkit4_thumb.png"),
      sources: [
        {
          prelabel: "1. UCLA School of Law, Williams Institute,",
          label:
            "More than 40% of transgender adults in the US have attempted suicide",
          sublabel: ". July 20, 2023.",
          link: "https://williamsinstitute.law.ucla.edu/press/transpop-suicide-press-release/",
        },
        {
          prelabel: "2.	SAMHSA,",
          label: "About Suicide and Suicidal Behavior",
          sublabel: ". November 22, 2024. ",
          link: "https://www.samhsa.gov/mental-health/suicidal-behavior/about",
        },
        {
          prelabel: "GLAAD, ",
          label: "Tips for Allies of Transgender People",
          sublabel: ". Accessed March 24, 2025.",
          link: "https://www.glaad.org/transgender/allies",
        },
      ],
      pdf: {
        link: "/assets/pdf/P365+_Transgender_Support.pdf",
        title: "You’re you",
        subtitle:
          "Colleague, friend, child, sibling, partner. <strong>Person.</strong>",
        img: {
          src: require("@assets/images/pdf_4.png"),
          placeholder: require("@assets/images/pdf_4_thumb.png"),
          alt: "LGBTQ+ Transgender support pdf",
          width: 280,
          height: 120,
        },
      },
    },
    {
      title: "Terminology & Pronouns",
      link: "/terminology-&-pronouns",
      background: require("@assets/images/toolkits/toolkit5_bg.png"),
      placeholder: require("@assets/images/toolkits/toolkit5_thumb.png"),
      sources: [
        {
          prelabel: "GLAAD, ",
          label: "Glossary of Terms: LGBTQ",
          sublabel: ". Accessed March 24, 2025.",
          link: "https://glaad.org/reference/terms/",
        },
        {
          label: "Human Rights Campaign: Glossary of Terms",
          sublabel: ".  May 31, 2023.",
          link: "https://www.hrc.org/resources/glossary-of-terms",
        },
        {
          label:
            "Human Rights Campaign: All Children All Families: Pronouns 101",
          sublabel: ". Accessed March 25, 2025.",
          link: "https://assets2.hrc.org/files/assets/resources/HRC_ACAF_Pronouns_101_(1).pdf",
        },
        {
          label:
            "The Trevor Project: Guide to Being an Ally to Transgender and Nonbinary Youth",
          sublabel: ". Accessed March 24, 2025.",
          link: "https://www.thetrevorproject.org/resources/trevor-support-center/a-guide-to-being-an-ally-to-transgender-and-nonbinary-youth/",
        },
      ],
      pdf: {
        link: "/assets/pdf/P365+_LGBTQ+_Terminology_and_Pronouns_Guide.pdf",
        title: "I’m she",
        subtitle: "You’re he. They’re them. <strong>People.</strong>",
        img: {
          src: require("@assets/images/pdf_5.png"),
          placeholder: require("@assets/images/pdf_5_thumb.png"),
          alt: "LGBTQ+ Terminology & Pronouns pdf",
          width: 280,
          height: 120,
        },
      },
    },
  ],
  disclaimer:
    "This program should not be used for emergency or urgent care needs. In an emergency, call 911 or go to the nearest emergency room. \nThis program is not a substitute for a doctor’s or professional’s care. Consult with your clinician for specific health care needs, \ntreatment or medication. Due to the potential for a conflict of interest, legal consultation will not be provided on issues that may involve \nlegal action against Optum or its affiliates, or any entity through which the caller is receiving these services directly or indirectly (e.g., \nemployer or health plan). This program and its components may not be available in all states or for all group sizes and is subject to \nchange. Coverage exclusions and limitations may apply.",
};
